import { render, staticRenderFns } from "./iHandUserTasks.vue?vue&type=template&id=afb69b84"
import script from "./iHandUserTasks.vue?vue&type=script&lang=js"
export * from "./iHandUserTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports